import React from "react";
import Skeleton from "react-loading-skeleton";
import { SERVER_HOST } from "../../../api/utils";
import styles from "./styles.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Image = ({ src, alt, ...props }) => {
  return (
    <div className={styles.imgWrapper}>

      <LazyLoadImage
        src={`${SERVER_HOST}${src}`}
        {...props}
        alt={alt}
        // height={200}
        // width={200}
      />


      {/* <img src={`${SERVER_HOST}${src}`} 
      {...props} 
      alt={alt}
       loading="lazy" /> */}
    </div>
  );
};

export const BrandImage = ({ src, alt, ...props }) => {
  return (
    <div className={styles.brandImgWrapper}>

      <LazyLoadImage
        src={`${SERVER_HOST}${src}`}
        {...props}
        style={{width:'50px', height: '50px'}}
        alt={alt}
        // height={100}
        // width={100}
      />


      {/* <img src={`${SERVER_HOST}${src}`} 
      {...props} 
      alt={alt}
       loading="lazy" /> */}
    </div>
  );
};



export const ImageWithoutWrapper = ({ src, alt, ...props }) => {
  return (
    <div className={styles.img}>

      <LazyLoadImage
        src={`${SERVER_HOST}${src}`}
        {...props}
        alt={alt}
        // height={200}
        // width={200}
      />

      {/* <img src={`${SERVER_HOST}${src}`} {...props} alt={alt} loading="lazy" /> */}
    </div>
  );
};
export const SimpleImage = ({ src, alt, ...props }) => {
  return (
    
    <LazyLoadImage
    src={`${SERVER_HOST}${src}`}
    {...props}
    // style={{height: '100%', width: '100%'}}
    alt={alt}
    // height={200}
    // width={200}
  />

    // <img src={`${SERVER_HOST}${src}`} {...props} alt={alt} loading="lazy" />
  );
};



export const ImageWithoutStyles = ({ src, alt, ...props }) => {
  return (
    <div className={styles.imageWithoutStyles}>
      
      <img
        src={`${SERVER_HOST}${src}`}
        {...props}
        alt={alt}
        // height={200}
        // width={200}
      />

      {/* <img src={`${SERVER_HOST}${src}`} {...props} alt={alt} loading="lazy" /> */}
    </div>
  );
};

export const ImageSkelton = ({ ...props }) => (
  <div className={styles.imgWrapper}>
    <Skeleton />
  </div>
);
export default Image;
